import React, {useState} from 'react';
import {curry} from 'ramda';
import moment from 'moment';
import classNames from 'classnames';
import {formatDateToServer} from '@pluto/react-select-mapping';
import DateFnsUtils from '@date-io/date-fns';
import {
    KeyboardDateTimePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import {
    handleModalState,
    getFormattedDueDateString,
} from '@pluto/utils';
import CreateIcon from '@material-ui/icons/Create';
import {QCFilters} from '../../../QCFilters/QCFiltersType';
import {SetQcJobDueDate} from '../../QCManagerTypes';

export interface DueDateQCModalContainerProps {
    dueDate: string | null;
    jobId: number;
    params: QCFilters;
    setQcJobDueDate: SetQcJobDueDate;
    setNotification: any;
}

export interface HandleDueDateChangeParams {
    jobId: number;
    params: QCFilters;
    setQcJobDueDate: SetQcJobDueDate;
    setNotification: any;
}

export const handleDueDateSingleChange = curry((handlers: HandleDueDateChangeParams, dateValue: string) => {
    const {
        jobId,
        params,
        setQcJobDueDate,
        setNotification,
    } = handlers;
    const body = [{
        id: jobId,
        dueDate: formatDateToServer(dateValue),
    }];
    const currentDate = new Date().toISOString();
    const pickedDate = new Date(dateValue).toISOString();
    const isBefore = moment(pickedDate).isBefore(currentDate);

    if (isBefore) {
        setNotification({
            type: 'error',
            text: `You can't change due date to past date`,
        });
    } else {
        setQcJobDueDate(body, params);
    }
});

export const getIsBeforeDate = (date: string | null) => {
    const currentDate = new Date().toISOString();
    const pickedDate = date ? new Date(date as string).toISOString() : '';

    return moment(pickedDate).isBefore(currentDate);
}

export default function DueDateQCModalContainer(props: DueDateQCModalContainerProps) {
    const {
        dueDate,
        jobId,
        params,
        setQcJobDueDate,
        setNotification,
    } = props;
    const [openDueDatePicker, setOpenDueDatePicker] = useState<boolean>(false);
    const onSingleDueDateChange = handleDueDateSingleChange({
        jobId,
        params,
        setQcJobDueDate,
        setNotification,
    });
    const isBeforeDate = getIsBeforeDate(dueDate);

    return (
        <div
            className={classNames('due-date__container', {
                isBeforeDate
            })}
        >
            {getFormattedDueDateString(dueDate)}
            <CreateIcon
                className="edit-icon"
                onClick={handleModalState(setOpenDueDatePicker, true)}
            />
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDateTimePicker
                    okLabel={<span className="date-picker__label date-picker__label_save">Save</span>}
                    cancelLabel={<span className="date-picker__label date-picker__label_cancel">Cancel</span>}
                    disablePast
                    showTodayButton
                    todayLabel={<span className="date-picker__label date-picker__label_today">Today</span>}
                    onClose={handleModalState(setOpenDueDatePicker, false)}
                    open={openDueDatePicker}
                    inputVariant="outlined"
                    format="MM-dd-yyyy HH:mm"
                    margin="normal"
                    placeholder="MM-dd-yyyy HH:mm"
                    value={dueDate || null}
                    onChange={onSingleDueDateChange}
                    ampm={false}
                />
            </MuiPickersUtilsProvider>
        </div>
    );
}
